import { ProgressBar, Text } from '@fluentui/react-components';

import type { UsageBreakdownProps } from './DatasetUsageSection.interface.js';
import { useStyles } from './DatasetUsageSection.style.js';

const DEFAULT_BAR_COLOR = 'brand' as const;
/** Floor for the divisor so an all-zero series never divides by zero. */
const MIN_MAX_COUNT = 1;

export function UsageBreakdown({ title, items }: UsageBreakdownProps) {
  const styles = useStyles();

  if (items.length === 0) {
    return null;
  }

  const maxCount = Math.max(...items.map((item) => item.count), MIN_MAX_COUNT);

  return (
    <div className={styles.breakdownCard}>
      <Text className={styles.breakdownTitle}>{title}</Text>
      {items.map((item) => (
        <div key={item.label} className={styles.breakdownRow}>
          <Text className={styles.breakdownLabel} title={item.label}>
            {item.label}
          </Text>
          <ProgressBar
            className={styles.progressBar}
            value={item.count / maxCount}
            color={item.color ?? DEFAULT_BAR_COLOR}
            thickness="large"
            shape="rounded"
            aria-label={`${title}: ${item.label}`}
          />
          <Text className={styles.breakdownCount}>{item.count}</Text>
        </div>
      ))}
    </div>
  );
}
